import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TabNavigation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const handleTabClick = (tabName) => {
        navigate(tabName);
    };

    return (
        <div className="tab-navigation-game">
            <div className="tab-game-title">Bao lô</div>
            <div className={location.pathname === "/xs75s/lo2" ? "active" : ""} onClick={() => handleTabClick("/xs75s/lo2")}>
                Lô 2 số
            </div>
            <div className={location.pathname === "/xs75s/lo2dau" ? "active" : ""} onClick={() => handleTabClick("/xs75s/lo2dau")}>
                Lô 2 số đầu
            </div>
            <div className={location.pathname === "/xs75s/lo2so1k" ? "active" : ""} onClick={() => handleTabClick("/xs75s/lo2so1k")}>
                Lô 2 số 1K
            </div>
            <div className={location.pathname === "/xs75s/lo3" ? "active" : ""} onClick={() => handleTabClick("/xs75s/lo3")}>
                Lô 3 số
            </div>
            <div className={location.pathname === "/xs75s/lo4" ? "active" : ""} onClick={() => handleTabClick("/xs75s/lo4")}>
                Lô 4 số
            </div>

            <div className="tab-game-title">Lô xiên</div>
            <div className={location.pathname === "/xs75s/loxien2" ? "active" : ""} onClick={() => handleTabClick("/xs75s/loxien2")}>
                Lô xiên 2
            </div>
            <div className={location.pathname === "/xs75s/loxien3" ? "active" : ""} onClick={() => handleTabClick("/xs75s/loxien3")}>
                Lô xiên 3
            </div>
            <div className={location.pathname === "/xs75s/loxien4" ? "active" : ""} onClick={() => handleTabClick("/xs75s/loxien4")}>
                Lô xiên 4
            </div>

            <div className="tab-game-title">Đánh đề</div>
            <div className={location.pathname === "/xs75s/dedb" ? "active" : ""} onClick={() => handleTabClick("/xs75s/dedb")}>
                Đề đặc biệt
            </div>
            <div className={location.pathname === "/xs75s/dedaudb" ? "active" : ""} onClick={() => handleTabClick("/xs75s/dedaudb")}>
                Đề đầu đặc biệt
            </div>
            <div className={location.pathname === "/xs75s/degiai7" ? "active" : ""} onClick={() => handleTabClick("/xs75s/degiai7")}>
                Đề giải 7
            </div>
            <div className={location.pathname === "/xs75s/de1" ? "active" : ""} onClick={() => handleTabClick("/xs75s/de1")}>
                Đề giải nhất
            </div>
            <div className={location.pathname === "/xs75s/dedau1" ? "active" : ""} onClick={() => handleTabClick("/xs75s/dedau1")}>
                Đề đầu giải nhất
            </div>

            <div className="tab-game-title">Đầu đuôi</div>
            <div className={location.pathname === "/xs75s/dau" ? "active" : ""} onClick={() => handleTabClick("/xs75s/dau")}>
                Đầu
            </div>
            <div className={location.pathname === "/xs75s/duoi" ? "active" : ""} onClick={() => handleTabClick("/xs75s/duoi")}>
                Đuôi
            </div>

            <div className="tab-game-title">3 càng</div>
            <div className={location.pathname === "/xs75s/3cangdau" ? "active" : ""} onClick={() => handleTabClick("/xs75s/3cangdau")}>
                3 càng đầu
            </div>
            <div className={location.pathname === "/xs75s/3cangdb" ? "active" : ""} onClick={() => handleTabClick("/xs75s/3cangdb")}>
                3 càng đặc biệt
            </div>
            <div className={location.pathname === "/xs75s/3cang1" ? "active" : ""} onClick={() => handleTabClick("/xs75s/3cang1")}>
                3 càng giải nhất
            </div>
            <div className={location.pathname === "/xs75s/3cangdauduoi" ? "active" : ""} onClick={() => handleTabClick("/xs75s/3cangdauduoi")}>
                3 càng đầu đuôi
            </div>

            <div className="tab-game-title">4 càng</div>
            <div className={location.pathname === "/xs75s/4cangdb" ? "active" : ""} onClick={() => handleTabClick("/xs75s/4cangdb")}>
                4 càng đặc biệt
            </div>

            <div className="tab-game-title">Lô trượt</div>
            <div className={location.pathname === "/xs75s/truotxien4" ? "active" : ""} onClick={() => handleTabClick("/xs75s/truotxien4")}>
                Trượt xiên 4
            </div>
            <div className={location.pathname === "/xs75s/truotxien8" ? "active" : ""} onClick={() => handleTabClick("/xs75s/truotxien8")}>
                Trượt xiên 8
            </div>
            <div className={location.pathname === "/xs75s/truotxien10" ? "active" : ""} onClick={() => handleTabClick("/xs75s/truotxien10")}>
                Trượt xiên 10
            </div>

            {/*<div className="tab-game-title">Trò chơi thú vị</div>
            <div className={location.pathname === "/xs75s/lo2db" ? "active" : ""} onClick={() => handleTabClick("/xs75s/lo2db")}>
                Lô 2 số giải ĐB
            </div>*/}
        </div>
    );
};

export default TabNavigation;
